var map = {
	"./logo-alicrim.png": 969,
	"./logo-ball.svg": 970,
	"./logo-cargill.png": 971,
	"./logo-gergo-app.png": 972,
	"./logo-gergo-branco.png": 215,
	"./logo-gergo.png": 973,
	"./logo-kanjiko.png": 974,
	"./logo-kanjiko.svg": 975,
	"./logo-rhyzos.svg": 976,
	"./logo-serasaexperian.png": 977,
	"./logo-sicredi.svg": 978,
	"./logo-vale.svg": 979,
	"./logo-veracel.png": 980,
	"./logo-vivo-256.png": 981,
	"./logo-vivo.png": 982,
	"./logo-vivo.svg": 983,
	"./vivo.svg": 984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;